import type { Currency } from '@ps/web-core-enums';
import type { TrackedTranslation } from '@ps/web-core-intl';

import type { CasinoGame } from '@swf/core/types/CasinoGame';

export enum PrizeType {
  NONE = 'NONE',
  ZERO = 'ZERO',
  IB = 'IB',
  CASH = 'CASH',
  FSB = 'FSB'
}

export enum RaceType {
  FEATURED = 'FEATURED_RACE',
  LDCNT = 'LDCNT_RACE'
}

export enum Status {
  NONE = 'NONE',
  CREATED = 'CREATED',
  ANNOUNCED = 'ANNOUNCED',
  REGOPEN = 'REGOPEN',
  STARTED = 'STARTED',
  REGCLOSED = 'REGCLOSED',
  COMPLETED = 'COMPLETED',
  CANCELLED = 'CANCELLED',
  ABORTED = 'ABORTED'
}

export interface Standing {
  rank: number;
  name: string;
  score: number;
  totalSpins: number;
  userRacePrize: Prize;
  amount: number;
  type: PrizeType;
}

export interface PrizeDetail {
  prizeType: PrizeType;
  currency: Currency;
  total: number;
  prizePositions: Prize[];
  numPrizePositions: number;
  compactPayouts: CompactPrize[];
}

export interface CompactPrize {
  startIndex: number;
  endIndex: number;
  prize: number;
}

export interface Prize {
  rank: number;
  type: PrizeType;
  currency?: Currency;
  amount: number;
}

export interface CasinoRace {
  id: string;
  name: string;
  prizeDetails: PrizeDetail;
  startTime: number;
  endTime: number;
  minBet: number;
  batchSize?: number;
  gameInfo: CasinoGame;
  multiGameList?: CasinoGame[];
  raceTypes: RaceType[];
  numOfPlayers: number;
  status: Status;
  leaderboard?: Standing[];
  liveRaceImgUrl?: string;
  userRaceStanding: Standing;
  feature?: boolean;
  tncVersion: number;
  promoUrl?: string;
}

export interface RaceTutorialPosition {
  rank: number;
  title: string;
  text: string;
}

export type RaceService = 'all' | 'user';

export interface RaceFilter {
  tag: TrackedTranslation;
  auth?: boolean;
  service: RaceService;
}

export interface StreamData {
  races: CasinoRace[];
  subscriptions: { [path: string]: string };
}
